import React, { useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import tw, { styled } from "twin.macro";
import { DatePicker, Image, Input, message, Select } from "antd";
import user from "../../assets/svg/user.svg";
import location from "../../assets/svg/location.svg";
import calender from "../../assets/svg/calender.svg";
import {
	btnStyle,
	hideScrollbar,
	inputStyle,
} from "../../lib/styles/styleLibrary";
import { isEmpty, Toast } from "../../lib/helpers/helpers";
import dayjs from "dayjs";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { getWedding } from "../../redux/reducers/weddingReducer";
import { editWedding, getTimezone } from "../../redux/actions/wedding";
import moment from "moment";
import copy from "../../assets/svg/copy.svg";
import { PageLoading } from "..";
import { useMutation } from "react-query";
import Auth from "../../lib/middleware/auth";

const Wrapper = styled.div`
	${tw`w-full md:w-9/12 overflow-y-scroll mt-8`}
	height: calc(100vh - 15rem);

	@media (max-width: 1023px) {
		width: 100% !important;
		height: calc(100vh - 15rem);
	}
	.label {
		${tw`text-appTextDark opacity-50 font-semibold text-sm md:text-base`}
	}

	.form-control {
		${tw`pt-3 flex flex-row flex-nowrap items-center justify-between gap-1 md:gap-4`}
	}

	.ant-input {
		font-size: 0.75rem;
	}
	.ant-select-selection-search-input {
		padding-top: 15px !important;
	}
	.ant-select-selection-item,
	.ant-select-selection-placeholder {
		padding-top: 10px !important;
		/* color: #dedef0 !important; */
	}
	.ant-select-selection-placeholder {
		color: #db0a0a !important;
	}
	.ant-select-selector {
		${tw`shadow-sm`}
		border-radius: 12px !important;
		height: 50px !important;
		min-width: 15rem !important;
		border: 1px solid #dedef0 !important;
	}
	.ant-picker-input > input {
		padding-left: 30px;
	}
	.ant-radio {
		top: 0;
	}
	.ant-radio-wrapper {
		${tw`inline-flex items-center`}
		font-size: 12px;
		line-height: 21px;
		color: #323232;
		opacity: 0.7;

		.ant-radio-inner {
			${tw`h-6 w-6`}
			background: rgba(20, 20, 20, 0.06);
			border: 1px solid #ff5a62;
			&::after {
				content: "";
				background: #fff;
				border: 1px solid #ddd;
				display: inline-flex;
				align-items: center;
				justify-content: center;
				width: 16px;
				height: 16px;
				padding: 2px;
			}
		}
		.ant-radio-checked {
			background: #ff5a62 !important;
			border: 1px solid #ff5a62 !important;
			border-radius: 50%;
		}
	}
`;

const GeneralSettings = (props) => {
	const { Option } = Select;
	const coupleData = Auth.getCouple();
	const dispatch = useDispatch();
	const weddingData = useSelector(getWedding);
	const [wd, setWd] = useState(moment(coupleData?.date));
	const [edit, setEdit] = useState(false);

	const [fields, setFields] = useState({
		date: dayjs(wd).format(),
		venue: coupleData?.venue,
		bride_firstname: coupleData?.bride_firstname,
		bride_lastname: coupleData?.bride_lastname,
		groom_firstname: coupleData?.groom_firstname,
		groom_lastname: coupleData?.groom_lastname,
		estimated_size: coupleData?.estimated_size,
		gmt_timezone: coupleData?.gmt_timezone,
	});

	useEffect(() => {
		dispatch(getTimezone());
		// eslint-disable-next-line
	}, []);

	// Wedding date and venue
	useEffect(() => {
		setFields({ ...fields, date: dayjs(wd).format() });
		// eslint-disable-next-line
	}, [wd]);

	const { mutateAsync: editWed, isLoading: editLoading } =
		useMutation(editWedding);

	const handleCheck = async () => {
		console.log();

		if (
			fields.bride_firstname === coupleData?.bride_firstname &&
			fields.bride_lastname === coupleData?.bride_lastname &&
			fields.groom_firstname === coupleData?.groom_firstname &&
			fields.groom_lastname === coupleData?.groom_lastname &&
			fields.venue === coupleData?.venue &&
			dayjs(fields.date).format("DD/MM/YYYY") ===
				dayjs(coupleData?.date).format("DD/MM/YYYY") &&
			fields.estimated_size === coupleData?.estimated_size &&
			fields.gmt_timezone === coupleData?.gmt_timezone
		) {
			Toast.fire({
				icon: "info",
				title: `No changes to save`,
			});
			return;
		}
		if (isEmpty(fields.date)) {
			Toast.fire({
				icon: "error",
				title: `Wedding Date field's is required`,
			});
			return;
		}
		if (isEmpty(fields.gmt_timezone)) {
			Toast.fire({
				icon: "error",
				title: `Timezone is required`,
			});
			return;
		}
		if (isEmpty(fields.venue)) {
			Toast.fire({
				icon: "error",
				title: `Venue is required`,
			});
			return;
		}
		if (
			isEmpty(fields.bride_firstname) ||
			isEmpty(fields.bride_lastname) ||
			isEmpty(fields.groom_firstname) ||
			isEmpty(fields.groom_lastname)
		) {
			Toast.fire({
				icon: "error",
				title: `Please enter names in full`,
			});
			return;
		}

		try {
			const response = await editWed(fields);
			console.log("Edit wedding res: =====>\n", response.data);
			const { hasError } = response.data;
			if (hasError) {
				Toast.fire({
					icon: "error",
					title: `${response.data.errors.title}\n ${response.data.errors.message} `,
				});
				return;
			}
			Toast.fire({
				icon: "success",
				title: `${response.data.message} \n Settings Saved`,
			});
			Auth.setCouple(response.data.data);
		} catch (err) {
			console.log("Error: ", err);
		}
	};

	return (
		<Wrapper css={hideScrollbar}>
			<div tw="flex justify-end items-center w-full">
				<button
					onClick={handleCheck}
					tw="bg-appLightPink text-appPink rounded-2xl font-semibold px-3 py-1 border-none hover:(shadow-md text-appPinkSaturated font-bold cursor-pointer)">
					Save
				</button>
			</div>
			<div>
				<div tw="">
					<label htmlFor="name" className="label">
						Groom's Name
					</label>
					<div className="form-control">
						<Input
							placeholder="Groom's First Name"
							type="text"
							css={inputStyle}
							value={fields.groom_firstname}
							onChange={(e) =>
								setFields({
									...fields,
									groom_firstname: e.target.value,
								})
							}
							tw="w-full md:w-6/12 text-sm!"
							prefix={
								<img
									src={user}
									alt=""
									width="22px"
									height="20px"
									tw="pr-2"
								/>
							}
						/>
						<Input
							placeholder="Groom's Last Name"
							type="text"
							value={fields.groom_lastname}
							onChange={(e) =>
								setFields({
									...fields,
									groom_lastname: e.target.value,
								})
							}
							css={inputStyle}
							tw="w-full md:w-6/12"
							prefix={
								<img
									src={user}
									alt=""
									width="22px"
									height="20px"
									tw="pr-2"
								/>
							}
						/>
					</div>
				</div>

				<div>
					<label htmlFor="name" className="label">
						Bride’s Name
					</label>
					<div className="form-control">
						<Input
							placeholder="First Name"
							type="text"
							css={inputStyle}
							value={fields.bride_firstname}
							onChange={(e) =>
								setFields({
									...fields,
									bride_firstname: e.target.value,
								})
							}
							tw="w-full md:w-6/12"
							prefix={
								<img
									src={user}
									width="22px"
									height="20px"
									alt=""
									tw="pr-2"
								/>
							}
						/>
						<Input
							placeholder="Last Name"
							type="text"
							value={fields.bride_lastname}
							onChange={(e) =>
								setFields({
									...fields,
									bride_lastname: e.target.value,
								})
							}
							css={inputStyle}
							tw="w-full md:w-6/12"
							prefix={
								<img
									src={user}
									width="22px"
									height="20px"
									alt=""
									tw="pr-2"
								/>
							}
						/>
					</div>
				</div>
			</div>
			<div tw="">
				<label htmlFor="name" className="label">
					Wedding Date
				</label>

				<div tw="relative mt-2">
					<div tw="absolute top-0 left-0 z-10">
						<img
							src={calender}
							alt=""
							width="25px"
							height="25px"
							tw="pr-2 absolute inset-3"
						/>
					</div>
					<DatePicker
						css={inputStyle}
						tw="w-full"
						suffixIcon={""}
						value={wd}
						disabledDate={(current) => {
							return current && current < moment();
						}}
						onChange={(date) => setWd(date)}
					/>
				</div>

				{!edit ? (
					<div
						onClick={() => setEdit(true)}
						// css={inputStyle}
						style={{ fontSize: "0.875rem" }}
						tw="text-gray-500 cursor-text text-appTextDark border-solid mb-4 px-2 py-2 md:(px-3 py-3) border border-transparent focus:outline-none! focus:ring-2! focus:ring-appLightPink!
						rounded-2xl shadow-sm!">
						{coupleData?.gmt_timezone}
					</div>
				) : (
					<Select
						showSearch
						placeholder="Select your timezone"
						value={fields.gmt_timezone}
						tw="w-full"
						onChange={(value) =>
							setFields({ ...fields, gmt_timezone: value })
						}>
						{weddingData?.timezone.map((zone, i) => {
							return (
								<Option value={zone.gmt_timezone} key={i}>
									{zone.gmt_timezone}
								</Option>
							);
						})}
					</Select>
				)}
			</div>

			<div tw="mt-4">
				<label htmlFor="name" className="label">
					Wedding Venue
				</label>
				<div className="form-control">
					<Input
						placeholder="Location"
						type="text"
						value={fields.venue}
						onChange={(e) =>
							setFields({
								...fields,
								venue: e.target.value,
							})
						}
						css={inputStyle}
						tw="w-full"
						prefix={<img src={location} alt="" tw="pr-2" />}
					/>
				</div>
			</div>

			<div tw="mt-4">
				<label htmlFor="name" className="label">
					Estimated guest size
				</label>
				<div className="form-control">
					<Input
						placeholder="0-100"
						type="text"
						value={fields.estimated_size}
						onChange={(e) =>
							setFields({
								...fields,
								estimated_size: e.target.value,
							})
						}
						css={inputStyle}
						tw="w-full"
						prefix={<img src={user} alt="" tw="pr-2" />}
					/>
				</div>
			</div>

			<div tw="mb-8">
				<div tw="mt-8 relative">
					<button
						css={btnStyle}
						tw="w-full text-sm text-appPink bg-appLightPink hover:(text-appPink bg-appLightPink shadow)"
						onClick={() => {
							navigator.clipboard.writeText(
								`weddingstory.ng/${coupleData?.page_url}`
							);
							message.success("Copied to clipboard");
						}}>
						weddingstory.ng/{coupleData?.page_url}
					</button>
					<span tw="absolute right-5 top-1/3 ">
						<Image
							preview={false}
							src={copy}
							alt=""
							width={18}
							height={20}
							tw="ml-2"
							onClick={() => {
								navigator.clipboard.writeText(
									`weddingstory.ng/${coupleData?.page_url}`
								);
								message.success("Copied to clipboard");
							}}
						/>
					</span>
				</div>
			</div>

			{editLoading && <PageLoading />}
		</Wrapper>
	);
};

export default GeneralSettings;
